/**
 * Expose has
 */

module.exports = has

/**
 * Vars
 */

var hasOwn = Object.prototype.hasOwnProperty

/**
 * has
 */

function has (prop, obj) {
  return hasOwn.call(obj, prop)
}



//////////////////
// WEBPACK FOOTER
// ../~/@f/has/lib/index.js
// module id = 1030
// module chunks = 0